import HeaderComponent from "../Component/HeaderComponent"
import SidebarComponent from "../Component/SidebarComponent"
import qrCodeIcon from '../Assets/icons/qrCodeIcon.svg'
import { useEffect, useState } from "react"
import CredencialsModal from "../Component/CredencialsModal"
import axiosInstance from "../Services/Api"
import { Await } from "react-router-dom"
import { useAuth } from "../Contexts/AuthContext"
import IpModal from "../Component/IpModal"
const CredentialsPage = () => {
    const [sidebarOpen, setSiidebarOpen] = useState(false)
    const [showCredencials, setShowCrwedentials] = useState(false)
    const [credentials, setCredentials] = useState(false)
    const [credentialsRes, setCredentialsRes] = useState(false)
    const [ips, setIps] = useState([])
    const { userData, getUserdata } = useAuth()
    const [ipModal, setIpModal] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const setSidebarOpen = (bool) => {
        window.localStorage.setItem('sidebarIsOpen', JSON.stringify(bool))
        setSiidebarOpen(bool)
    }
    const getCredentials = async () => {
        try {
            const response = await axiosInstance.get('/api/credentials')
            setCredentials(response.data)
        } catch (e) {
            if (e.status === 401) {
                localStorage.removeItem('token')
                window.location.reload()
            }
        }
    }
    useEffect(() => {
        const localSidebarStorage = JSON.parse(window.localStorage.getItem('sidebarIsOpen'))
        setSiidebarOpen(localSidebarStorage)
        getCredentials()
        getUserdata()
        getIps()
        setIsLoading(false)

    }, [])

    const getIps = async () => {
        try {
            const response = await axiosInstance.post('/api/getIp')
            console.log(response.data)
            setIps(response.data.ips)
        } catch (e) {
            if (e.status === 401) {
                localStorage.removeItem('token')
                window.location.reload()
            }
        }
    }

    const handleDeleteIp = async (ip) => {
        const confirmDelete = window.confirm('Deseja realmente deletar o IP?'); // Use window.confirm for clarity
        if (confirmDelete) {
            try {
                await axiosInstance.post('/api/desactiveIp', { ip: ip }); // Use await to handle the promise
                alert('IP deletado com sucesso');
                window.location.reload();
            } catch (e) {
                if (e.response && e.response.status === 401) { // Check for response status
                    localStorage.removeItem('token');
                    window.location.reload();
                } else {
                    alert('Ocorreu um erro ao tentar deletar o IP. Contate o suporte.');
                }
            }
        }
    };
    const handleDefineCredentials = async () => {

        try {
            const response = await axiosInstance.post('/api/credentials')

            setCredentialsRes(response.data.success)
            setShowCrwedentials(!showCredencials)
        } catch (e) {
            if (e.status === 401) {
                localStorage.removeItem('token')
                window.location.reload()
            }
        }
    }

    if (isLoading) {
        return (
            <div className="w-full flex h-screen bg-[#171717]">
                <IpModal isOpen={ipModal} onClose={setIpModal} />
                <SidebarComponent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <div className={`${sidebarOpen ? 'md:ml-[250px]' : 'md:ml-[100px]'}  text-white w-full  md:mt-8`}>
                    <HeaderComponent setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} title={'Bem vindo(a) a dxpay !'} subTitle={'Seja bem-vindo ao painel de controle da sua empresa'} />
                    <div className="md:static relative z-[99999] px-4">
                        <div className="flex justify-center h-screen items-center mt-8">
                            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-500"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full flex h-screen bg-[#171717]">
            <IpModal isOpen={ipModal} onClose={setIpModal} />
            <SidebarComponent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className={`${sidebarOpen ? 'md:ml-[250px]' : 'md:ml-[100px]'}  text-white w-full  md:mt-8`}>
                <HeaderComponent setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} title={'Bem vindo(a) a dxpay !'} subTitle={'Seja bem-vindo ao painel de controle da sua empresa'} />
                <div className="md:static relative z-[99999] px-4">
                    {credentials || credentialsRes ?
                        <p className="text-[red] my-3">Credencias ja geradas !</p>
                        : <div onClick={handleDefineCredentials} className="flex cursor-pointer my-8 text-white w-[250px] gap-3 items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                            <img src={qrCodeIcon} />
                            <p>Definir credenciais de api</p>
                        </div>
                    }
                    {credentials ?
                        <>
                            <table className="w-full text-left">
                                <thead className="text-[14px] w-full border-b pb-2  border-[#343B4F] justify-between ">
                                    <th className="">Client Id</th>
                                    <th className="">Status</th>
                                    <th className="">Data de crição</th>
                                </thead>
                                <tbody className="text-left">
                                    <tr className="text-[12px] w-full justify-between">
                                        <td className=" pt-2"></td>
                                        <td className="  pt-2"></td>
                                        <td className=" pt-2"></td>
                                    </tr>
                                    <tr className="text-[12px] w-full text-left justify-between">
                                        <td className="">{credentials.clientId}</td>
                                        <td className=" "><div className="flex items-center  text-[14px] text-[#A1E3CB] gap-3">
                                            <div className="p-1 w-[15px] h-[15px] rounded-[100%] bg-[#A1E3CB]"></div>
                                            Ativo
                                        </div></td>
                                        <td className="">{new Date(credentials.created_at).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="flex my-8 text-white  gap-3 items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.6279 9.40621C12.6857 9.50648 12.7014 9.62557 12.6715 9.73739C12.6417 9.84922 12.5688 9.94467 12.4688 10.0028L7.21875 13.0653C7.15185 13.1044 7.0758 13.1249 6.99836 13.1249C6.92092 13.1249 6.84487 13.1044 6.77797 13.0653L1.52797 10.0028C1.42936 9.94359 1.35806 9.84789 1.32951 9.73645C1.30095 9.62501 1.31744 9.50681 1.37539 9.40744C1.43335 9.30806 1.52811 9.23552 1.63916 9.2055C1.75022 9.17548 1.86863 9.19042 1.96875 9.24707L7 12.1811L12.0312 9.24707C12.1315 9.18928 12.2506 9.17358 12.3624 9.20341C12.4743 9.23324 12.5697 9.30616 12.6279 9.40621ZM12.0312 6.62207L7 9.55605L1.96875 6.62207C1.86913 6.57247 1.75436 6.56269 1.64779 6.59473C1.54122 6.62677 1.45087 6.69822 1.39512 6.79453C1.33937 6.89083 1.32241 7.00477 1.3477 7.11314C1.37299 7.22151 1.43863 7.31616 1.53125 7.37785L6.78125 10.4403C6.84815 10.4794 6.9242 10.4999 7.00164 10.4999C7.07908 10.4999 7.15513 10.4794 7.22203 10.4403L12.472 7.37785C12.5225 7.34932 12.5667 7.31106 12.6022 7.26529C12.6377 7.21952 12.6638 7.16715 12.6789 7.11122C12.6941 7.05529 12.6979 6.99691 12.6903 6.93948C12.6827 6.88205 12.6637 6.8267 12.6345 6.77666C12.6053 6.72661 12.5665 6.68286 12.5203 6.64794C12.474 6.61303 12.4213 6.58764 12.3652 6.57326C12.3091 6.55888 12.2507 6.55579 12.1933 6.56417C12.136 6.57254 12.0809 6.59222 12.0312 6.62207ZM1.3125 4.37496C1.31267 4.29833 1.33297 4.22309 1.37136 4.15677C1.40975 4.09045 1.46489 4.03538 1.53125 3.99707L6.78125 0.934566C6.84815 0.895555 6.9242 0.875 7.00164 0.875C7.07908 0.875 7.15513 0.895555 7.22203 0.934566L12.472 3.99707C12.5381 4.0356 12.5929 4.09076 12.6309 4.15707C12.669 4.22337 12.6891 4.2985 12.6891 4.37496C12.6891 4.45142 12.669 4.52654 12.6309 4.59285C12.5929 4.65915 12.5381 4.71432 12.472 4.75285L7.22203 7.81535C7.15513 7.85436 7.07908 7.87491 7.00164 7.87491C6.9242 7.87491 6.84815 7.85436 6.78125 7.81535L1.53125 4.75285C1.46489 4.71453 1.40975 4.65946 1.37136 4.59314C1.33297 4.52682 1.31267 4.45159 1.3125 4.37496ZM2.61844 4.37496L7 6.93105L11.3816 4.37496L7 1.81886L2.61844 4.37496Z" fill="white" />
                                </svg>
                                <p>Ip's permitidos</p>
                            </div>
                            <div className="w-full flex flex-col gap-3">
                                <div className="border-b flex py-2 w-full border-[#343B4F]">
                                    <p>IP</p>
                                </div>
                                {ips.length >= 1 ? ips.map((data) => {
                                    return <div className="border-b pr-10 flex justify-between py-2 w-full border-[#343B4F]">
                                        <p>{data.ip}</p>
                                        <div className="flex gap-2 items-center  text-[14px] text-[#A1E3CB] gap-3">
                                            <div className={`p-1 w-[15px] h-[15px] rounded-[100%] bg-[#A1E3CB]`}></div>
                                            {data.status ? 'Ativo' : 'Inativo'}
                                            <svg onClick={() => { handleDeleteIp(data.ip) }} className="cursor-pointer" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_56_5344)">
                                                    <path d="M11.2299 7.68825L9.00144 9.91667L11.2299 12.1451C11.368 12.2832 11.368 12.5078 11.2299 12.6459C11.1604 12.7153 11.0698 12.7493 10.9791 12.7493C10.8884 12.7493 10.7978 12.7146 10.7284 12.6459L8.49994 10.4175L6.27153 12.6459C6.20211 12.7153 6.11144 12.7493 6.02078 12.7493C5.93011 12.7493 5.83944 12.7146 5.77003 12.6459C5.6319 12.5078 5.6319 12.2832 5.77003 12.1451L7.99844 9.91667L5.77003 7.68825C5.6319 7.55012 5.6319 7.32558 5.77003 7.18746C5.90815 7.04933 6.13269 7.04933 6.27082 7.18746L8.49923 9.41587L10.7277 7.18746C10.8658 7.04933 11.0903 7.04933 11.2284 7.18746C11.3666 7.32558 11.3666 7.55012 11.2284 7.68825H11.2299ZM16.2916 3.1875C16.2916 3.383 16.1329 3.54167 15.9374 3.54167H14.8749C14.8749 3.55229 14.8749 3.56292 14.8735 3.57425L13.9031 14.105C13.7508 15.7555 12.3859 17 10.7291 17H6.2864C4.63103 17 3.26678 15.7576 3.11307 14.11L2.12707 3.57496C2.12636 3.56362 2.12565 3.553 2.12565 3.54167H1.06315C0.867651 3.54167 0.708984 3.383 0.708984 3.1875C0.708984 2.992 0.867651 2.83333 1.06315 2.83333H4.62465C4.80173 1.24171 6.15465 0 7.79232 0H9.20898C10.8467 0 12.2003 1.24171 12.3767 2.83333H15.9382C16.1337 2.83333 16.2916 2.992 16.2916 3.1875ZM5.33794 2.83333H11.6619C11.4898 1.63342 10.4549 0.708333 9.20828 0.708333H7.79161C6.54494 0.708333 5.51007 1.63342 5.33794 2.83333ZM14.1652 3.54167H2.83469L3.81715 14.0434C3.93615 15.3255 4.99794 16.2917 6.28498 16.2917H10.7277C12.0168 16.2917 13.0779 15.3241 13.1962 14.0399L14.1638 3.54167H14.1652Z" fill="#FF0000" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_56_5344">
                                                        <rect width="17" height="17" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                }) : <div></div>}
                            </div>
                            <div onClick={() => { setIpModal(true) }} className="flex my-8 text-white w-[130px] cursor-pointer gap-3 items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                                <img src={qrCodeIcon} />
                                <p>Adicionar IP</p>
                            </div>
                        </>
                        : ""}

                    {showCredencials && <CredencialsModal credentials={credentialsRes} setModalOpen={setShowCrwedentials} />}
                </div>


            </div>
        </div>
    )
}

export default CredentialsPage